import React from "react";
import { BtnWspBubble } from "./Icon";
import "./WhatsAppBubble.css";

const WhatsAppBubble = () => {
  return (
    <div className="container">
      <div className="sticky__wsp__bubble d-md-block d-lg-block d-block">
        <a
          className="btn__wsp__bubble"
          href="https://wa.me/525554582423"
          target="_blank"
          rel="noreferrer"
        >
          <BtnWspBubble />
        </a>
      </div>
    </div>
  );
};

export default WhatsAppBubble;
